import styled from 'styled-components';
import { LOW_WHITE } from '../../styles/Colors';

export const AboutUsContainer = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 45px 0px 0px 0px;
`;
export const AboutUsTitle = styled.h1`
  font-size: 3em;
  margin: 0;
  font-weight: bold;
  margin-bottom: 20px;
`;
